module.exports = __webpack_public_path__ + "img/65.cddd0f5a.png";